<template>
  <div class="text-left">
    <h5 class="text-center">
      <strong>{{ $t("name") }}:</strong> {{ title }}
      <span class="ml-5" v-if="supervisor"
        ><strong> Supervisor:</strong> {{ supervisor.username }}</span
      >
    </h5>
    <v-divider />
    <v-card>
      <form class="pa-6">
            <v-col cols="12" class="py-0" v-if="similarities && similarities.length > 0">
              <v-alert
                class="mb-8 d-block mt-3"
                style="max-width: 100%; overflow: hidden; text-overflow: ellipsis;"
                color="yellow darken-4"
                icon="mdi-alert-box"
                type="warning"
                text
              >
                {{  $t('form.researcher.similaritiesAdmin') }}
                <v-list light style="margin-left:-0.5em;">
                  <v-list-item v-for="similarity in similarities" :key="similarity.id">
                    <v-list-item-content>
                      <v-list-item-title dark>
                        <v-btn :to="'/manage/edit/researchers/edit/' + similarity.id" target="_blank" outlined style="white-space: break-spaces;">{{ similarity.preferred_name.given_name + " " + similarity.preferred_name.family_name }}</v-btn>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-alert>
            </v-col>
            <h5>
              {{ $t("form.givenAndFamilyName") }}
            </h5>
            <v-row>
              <v-col cols="12" md="6" class="pb-0">
                <v-text-field
                  v-model="investigator.person.preferred_name.given_name"
                  @blur="normalizePersonNameField(investigator.person.preferred_name, 'given_name')"
                  :label="$t('form.name')"
                  required
                  outlined
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="pb-0">
                <v-text-field
                  v-model="investigator.person.preferred_name.family_name"
                  @blur="normalizePersonNameField(investigator.person.preferred_name, 'family_name')"
                  :label="$t('form.familyName')"
                  required
                  outlined
                  readonly
                ></v-text-field>
              </v-col>
            </v-row>
            <h5>{{ $t("form.email") }}</h5>
            <ArrayFieldForm
              v-model="investigator.person.email"
              :read-only="true"
              name-field="email"
              :label="$t('form.email')"
            />
            <h5>{{ $t("form.incharge") }}</h5>
            <SelectPeopleList
              :disabled-form="true"
              :items-selected="investigator.person.incharge"
            />
         
            <v-row>
              <v-col cols="12" md="6" class="pb-0">
                <h5>
                  {{ $t("form.dni") }}
                </h5>
                <v-row>
                  <v-col cols="4" class="pb-0">
                    <v-select
                      v-model="investigator.person.id_number.type"
                      :label="$t('type')"
                      outlined
                      :items="identificationOptions"
                      item-text="text"
                      item-value="value"
                      readonly
                    ></v-select
                  ></v-col>
                  <v-col cols="8" class="pb-0">
                    <v-text-field
                      v-model="investigator.person.id_number.value"
                      :label="$t('label.value')"
                      required
                      outlined
                      readonly
                    >
                    </v-text-field>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" md="3" class="pb-0">
                <h5>
                  {{ $t("form.mobile") }}
                </h5>
                <v-row>
                  <v-col class="pb-0">
                    <v-text-field
                      v-model="investigator.person.number"
                      outlined
                      :label="$t('form.mobile')"
                      readonly
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" md="3" class="pb-0">
                <h5>{{ $t("form.gender") }}</h5>
                <v-row>
                  <v-col class="pb-0 mt-1">
                    <v-btn-toggle
                      v-model="investigator.person.gender"
                      mandatory
                      disabled=""
                    >
                      <v-btn value="male" class="disable-events">
                        {{ $t("form.male") }}
                      </v-btn>
                      <v-btn value="female" class="disable-events">
                        {{ $t("form.female") }}
                      </v-btn>
                    </v-btn-toggle>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <h5>{{ $t("form.vinculation") }}</h5>
            <div>
              <v-row>
                <v-col cols="12" sm="6" class="pb-0">
                  <v-combobox
                    v-model="categorySelected"
                    :items="categories"
                    item-text="internal_name"
                    :label="$t('label.category')"
                    return-object
                    outlined
                    readonly
                  ></v-combobox>
                </v-col>
                <v-col cols="12" sm="6" class="pb-0">
                  <v-select
                    v-model="investigator.vinculation.type"
                    :items="vinculationTypes"
                    item-value="value"
                    item-text="text"
                    :label="$t('type')"
                    outlined
                    readonly
                  ></v-select
                ></v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="6" class="pb-0">
                  <v-text-field
                    v-model="investigator.vinculation.start_date"
                    :label="$t('label.startDate')"
                    prepend-inner-icon="event"
                    readonly
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" class="pb-0">
                  <v-text-field
                    v-model="investigator.vinculation.end_date"
                    :label="$t('label.endDate')"
                    prepend-inner-icon="event"
                    readonly
                    outlined
                  ></v-text-field>
                </v-col>
              </v-row>
            </div>

            <h5 class="pt-3">{{ $t("form.citicenships") }}</h5>
            <v-row>
              <v-col cols="12">
                <ArrayFieldForm
                  v-model="investigator.person.citicenship"
                  name-field="citicenship"
                  :label="$t('form.citicenships')"
                />
              </v-col>
            </v-row>

            <h5>
            {{ $t("form.procedence") }}
            </h5>
            <v-text-field
              v-model="investigator.procedence"
              outlined
              :label="$t('form.procedence')"
              readonly
            ></v-text-field>

            <h5>
              {{ $t("forms.building") }}
            </h5>
            <v-row>
              <v-col cols="12">
                <v-combobox
                  v-model="workplaceSelected"
                  :items="workplaces"
                  item-text="name"
                  :label="$t('label.laboratory')"
                  return-object
                  outlined
                  readonly
                ></v-combobox>
              </v-col>
            </v-row>

            <h5>
            {{ $t("form.motivation") }}
            </h5>
            <v-text-field
              v-model="investigator.motivation"
              outlined
              :label="$t('form.motivation')"
              readonly
            ></v-text-field>

            <h5>
              {{ $t("form.equipment") }}
            </h5>
            <v-text-field
              v-model="investigator.equipment"
              outlined
              :label="$t('form.equipment')"
              readonly
            ></v-text-field>
          
            <h5 class="bold text-left mb-5">
              {{ $t("form.list.additional.services") }}
            </h5>
            <v-row>
              <v-col
                cols="12"
                sm="6"
                md="4"
                lg="3"
                v-for="(service, index) in sortedServices"
                :key="index"
                class="py-0"
              >
                <v-checkbox
                  v-model="investigator.account.services"
                  :label="service.name"
                  :value="service.id"
                  readonly
                  off-icon="mdi-close"
                  on-icon="mdi-check-circle"
                  class="py-0 my-0"
                  dense
                />
              </v-col>
            </v-row>

      <v-divider />
      <DirectorActions
        v-if="isAuthorize"
        :object_type="object_type"
        class="text-center"
      />
      <SupervisorActions
        v-else
        :item="investigator"
        :object_type="object_type"
        :form_name="form_name"
        :state="state"
        :supervisor="supervisor !== null ? supervisor.username : ''"
        @change-state-supervisor="onStateSupervisorChange"
      />
      </form>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import DirectorActions from "../../action_buttons/DirectorActions";
import SupervisorActions from "../../action_buttons/SupervisorActions";
import ArrayFieldForm from "../../reusables/ArrayFieldForm";
import SelectPeopleList from "../../reusables/SelectPeopleList";
import investigatorData from "../../../mixins/investigator_data";
import investigator_model from "../../../mixins/model_utils/investigator_model";

export default {
  mixins: [investigatorData, investigator_model],
  components: {
    SelectPeopleList,
    DirectorActions,
    SupervisorActions,
    ArrayFieldForm
  },

  props:{
    similarities: {
      type: Array,
      default: () => [],
    },
  },

  data: () => ({
    step: 1,
    categorySelected: "",
    workplaceSelected: "",
    tab: null,
    menu: false,
    menu_start_day: false,
    menu_end_date: false,
    state: "",
    title: "",
    form_name: "",
    reject_comment: "",
    supervisor: "",
    object_type: ""
  }),

  computed: {
    isAuthorize() {
      return this.$route.meta.authorize !== undefined;
    }
  },

  created() {
    this.getServices();
    this.getResearchAreas();
    this.getWorkplaces();
    this.getCategories();
    this.getVinculationTypes();
    this.getData();
  },

  methods: {
    loadWorkplaceSelected(item) {
      if (typeof item == "number") {
        this.workplaceSelected = this.workplaces.filter(
          workplace => workplace.id === item
        )[0];
      } else {
        this.workplaceSelected = item;
      }
    },
    loadCategorySelected(item) {
      if (typeof item == "number") {
        this.categorySelected = this.categories.filter(
          category => category.id === item
        )[0];
      } else {
        this.categorySelected = item;
      }
    },

    getData() {
      let path;
      if (this.isAuthorize) {
        path =
          this.$store.state.endpoint +
          "/direction/moderatedOperations/authorize/investigator/" +
          this.$route.params.id;
      } else {
        path =
          this.$store.state.endpoint +
          "/moderatedOperations/review/investigator/" +
          this.$route.params.id;
      }

      axios
        .get(path)
        .then(response => {
          this.investigator = response.data.data.user;
          this.reject_comment = response.data.reject_comment;
          this.form_name = response.data.form_name;
          this.title = response.data.title;
          this.state = response.data.state;
          this.supervisor = response.data.supervisor;
          this.object_type = response.data.object_type;
          this.investigator.id = response.data.object_id;
          this.loadWorkplaceSelected(this.investigator.person.workplace);
          this.loadCategorySelected(this.investigator.vinculation.category);
          if(["vd","pv","pa"].includes(this.state.toLowerCase()) ){
            axios({ url: this.$store.state.endpoint + "/similar/person", method: "GET", params: { search: this.investigator.person.preferred_name.given_name + " " + this.investigator.person.preferred_name.family_name } })
            .then(resp => {
              this.similarities = resp.data;
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },

    onStateSupervisorChange(state, supervisor) {
      this.state = state;
      this.supervisor = supervisor;
    }
  }
};
</script>
